import Result from './result/LabResearchOrderTestResultInitialState'

const { Record } = require('immutable')

export default Record({
    result: Result()
})